import moment from 'moment-timezone';

export const entityId = {
    field: 'entityId',
    headerName: 'Right ID',
    width: 100,
};

export const action = {
    field: 'action',
    headerName: 'Status',
    width: 100,
};

export const timestamp = {
    field: 'timestamp',
    headerName: 'Timestamp (UTC)',
    valueFormatter: ({ value }) => (value ? moment(value).tz('UTC').format('MM-DD-YYYY, hh:mm:ss A') : ''),
    width: 175,
};


export const timestampPDT = {
    field: 'timestamp',
    headerName: 'Timestamp (Pacific time)',
    valueFormatter: ({ value }) => (value ? moment(moment(value).tz('America/Los_Angeles')).format('MM-DD-YYYY, hh:mm:ss A') : ''),
    width: 175,    
};

export const catalogId = {
    field: 'catalogId',
    headerName: 'Catalog ID',
    width: 100,
};

export const catalogName = {
    field: 'catalogName',
    headerName: 'Catalog Name',
    width: 300,
    tooltipValueGetter: ({ value }) => (value ? value : ''),
};

export const initialReleaseDate = {
    field: 'initialReleaseDate',
    headerName: 'Initial Release Date',
    width: 125,
    tooltipValueGetter: ({ value }) => (value ? value : ''),
};

export const releasingCompany = {
    field: 'releasingCompany',
    headerName: 'Releasing Company',
    width: 200,
    tooltipValueGetter: ({ value }) => (value ? value : ''),
};

export const runtimeInMins = {
    field: 'runtimeInMins',
    headerName: 'Runtime in Mins',
    width: 125,    
};

export const originalLanguage = {
    field: 'originalLanguage',
    headerName: 'Original Language',
    width: 125,    
    tooltipValueGetter: ({ value }) => (value ? value : ''),
};

export const termStart = {
    field: 'termStart',
    headerName: 'Term Start',    
    width: 125,
};

export const termEnd = {
    field: 'termEnd',
    headerName: 'Term End',    
    width: 125,
};

export const media = {
    field: 'media',
    headerName: 'Media',    
    width: 400,
    tooltipValueGetter: ({ value }) => (value ? value : ''),
};

export const territory = {
    field: 'territory',
    headerName: 'Territory',    
    width: 250,
    tooltipValueGetter: ({ value }) => (value ? value : ''),
};

export const language = {
    field: 'language',     
    headerName: 'Language',    
    width: 250,    
    tooltipValueGetter: ({ value }) => (value ? value : ''),
};

export const description = {
    field: 'description',
    headerName: 'Description',    
    width: 250,
    tooltipValueGetter: ({ value }) => (value ? value : ''),
};

export const format = {
    field: 'format',
    headerName: 'Format',    
    width: 250,
};

export const offerTableId = {
    field: 'offerTableId',
    headerName: 'Offer Table ID',    
    width: 250,
};